import Vue from 'vue'
import Router from 'vue-router'

import Index from './views/Index.vue'
import Login from "./views/Login.vue";
import AreaOperatore from "./views/AreaOperatore.vue";
import ClientChat from "./views/ClientChat.vue";

Vue.use(Router)

export default new Router({
    routes: [
      {
        path: '*',
        name: 'index',
        component: Index
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
      path: '/area-operatore',
      name: 'AreaOperatore',
      component: AreaOperatore
    },
    {
      path: '/client-chat',
      name: 'ClientChat',
      component: ClientChat
    }
    ]
})